import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatApprovalCardDefaultVariants = {
  "state": "request"
}
const chatApprovalCardCompoundVariants = []

const chatApprovalCardSlotNames = [
  [
    "root",
    "chatApprovalCard__root"
  ],
  [
    "header",
    "chatApprovalCard__header"
  ],
  [
    "icon",
    "chatApprovalCard__icon"
  ],
  [
    "headings",
    "chatApprovalCard__headings"
  ],
  [
    "title",
    "chatApprovalCard__title"
  ],
  [
    "description",
    "chatApprovalCard__description"
  ],
  [
    "detail",
    "chatApprovalCard__detail"
  ],
  [
    "actions",
    "chatApprovalCard__actions"
  ],
  [
    "buttons",
    "chatApprovalCard__buttons"
  ],
  [
    "status",
    "chatApprovalCard__status"
  ]
]
const chatApprovalCardSlotFns = /* @__PURE__ */ chatApprovalCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatApprovalCardDefaultVariants, getSlotCompoundVariant(chatApprovalCardCompoundVariants, slotName))])

const chatApprovalCardFn = memo((props = {}) => {
  return Object.fromEntries(chatApprovalCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatApprovalCardVariantKeys = [
  "state"
]
const getVariantProps = (variants) => ({ ...chatApprovalCardDefaultVariants, ...compact(variants) })

export const chatApprovalCard = /* @__PURE__ */ Object.assign(chatApprovalCardFn, {
  __recipe__: false,
  __name__: 'chatApprovalCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatApprovalCardVariantKeys,
  variantMap: {
  "state": [
    "request",
    "running",
    "approved",
    "denied",
    "cancelled",
    "expired"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatApprovalCardVariantKeys)
  },
  getVariantProps
})